import React     from 'react';
import PropTypes from 'prop-types';

const menuOptions = [
  { id: 'setup', label: 'Setup Community' },
  //  { id: 'paywall', label: 'Setup Paywall' },
  { id: 'members', label: 'Invite Members' }
  //  { id: 'engagement', label: 'Kickstart Engagement' },
  // { id: 'leadership', label: 'Join Leadership Community' }
]

const OnboardingMenu = ({ selectedOption, handleChangeTab }) => {
  return (
    <div className='col-sm-3 menu'>
      <p className='fs-23 w3'>Your checklist</p>
      <div className='mt-40'>
        { menuOptions.map(({ id, label }) =>
          <p
            key={id}
            className={`menu-label fs-15 w3 ${selectedOption == id ? 'selected' : ''}`}
            onClick={() => handleChangeTab(id)}
          >
            {label}
          </p>
        )}
      </div>
    </div>
  );
};

OnboardingMenu.propTypes = {
  selectedOption: PropTypes.string.isRequired,
  handleChangeTab: PropTypes.func.isRequired
};

export default OnboardingMenu;
